import { Component, Input, OnInit } from '@angular/core';
import { NavigationTabData } from 'src/app/models/navigation-tab-data.model';
import { Navigator } from '../menu/navigator';

@Component({
  selector: 'navigation-tabs',
  templateUrl: './navigation-tabs.component.html',
  styleUrls: ['./navigation-tabs.component.scss'],
})
export class NavigationTabsComponent implements OnInit {
  constructor(private navigator: Navigator) { }

  @Input() tabData: NavigationTabData[] = [];
  ngOnInit() {
  }

  tabClicked(tabDatum) {
      this.navigator.navigateTo(tabDatum.link, { multipleModals: true}, {navigationFromWinLoss: true});
  }

}
